export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const FORGOT = "FORGOT";
export const VERIFY = "VERIFY";
export const VERIFYPHONENUMBER = "VERIFYPHONENUMBER";

export const GET_PAYMENTS = "GET_PAYMENTS";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_ALL_USERS_TEST = "GET_ALL_USERS_TEST";
export const GET_ALL_ENTRIES = "GET_ALL_ENTRIES";
export const GET_ALL_INVESTORS = "GET_ALL_INVESTORS";
export const GET_PAGED_ENTRIES = "GET_PAGED_ENTRIES";
export const GET_PAGED_INVESTORS = "GET_PAGED_INVESTORS";
export const GET_USER = "GET_USER";
export const GET_USERS_BY_ROLE = "GET_USERS_BY_ROLE";
export const ADD_USER_BY_ROLE = "ADD_USER_BY_ROLE";

// Tractor Constants
export const GET_ALL_TRACTORS = "GET_ALL_TRACTORS";
export const GET_ALL_INVESTMENT_UNITS = "GET_ALL_INVESTMENT_UNITS";
export const GET_ALL_INVESTMENT_UNITS_ARR = "GET_ALL_INVESTMENT_UNITS_ARR";
export const GET_ALL_USER_TRACTORS = "GET_ALL_USER_TRACTORS";
export const ADD_TRACTOR = "ADD_TRACTOR";
export const HIRE_TRACTOR = "HIRE_TRACTOR";
export const GET_TRACTOR_PROFILE = "GET_TRACTOR_PROFILE";

// Leasing Constants
export const TRACTOR_VERIFIED = "TRACTOR_VERIFIED";
export const ALL_LEASE_REQUEST = "ALL_LEASE_REQUEST";
export const ALL_FARMERS = "ALL_FARMERS";
export const ALL_AGENTS = "ALL_AGENTS";
export const USER_LEASE_REQUEST = "USER_LEASE_REQUEST";
export const FILTER_LEASE_BY_STATUS = "FILTER_LEASE_BY_STATUS";
export const TRACTOR_ASSIGNED_SUCCESSFULLY = "TRACTOR_ASSIGNED_SUCCESSFULLY";
export const PENDING_LEASE_REQUEST = "PENDING_LEASE_REQUEST";
export const ASSIGNED_LEASE_REQUEST = "ASSIGNED_LEASE_REQUEST";

// Investment Constants
export const ADD_INVESTMENT = "ADD_INVESTMENT";
export const GET_USER_INVESTMENT = "GET_USER_INVESTMENT";
export const GET_ALL_INVESTMENT = "GET_ALL_INVESTMENT";
